import { __ } from "@service/api-client/http/helpers/translates";
const bettorsTournamentPrizes = {
  1: {
    place: [1],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._1 place"),
    name: __("Bettors Tournament Single Board_._Prizes 1_._70&nbsp;000&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-1.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-1.png",
    imagePrize: "/assets/bettors-tournament/prizes/cup-1.png",
    imagePrizeStyles: {
      top: "13px",
      left: "33px",
      height: "75%"
    },
    imagePrizesBackgroundStyles: {
      top: "-1px",
      left: "0"
    },
    imagePrizeStylesWide: {
      top: "18px",
      left: "47px",
      height: "75%"
    }
  },
  2: {
    place: [2],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._2 place"),
    name: __("Bettors Tournament Single Board_._Prizes 2_._35&nbsp;000&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-2.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-2.png",
    imagePrize: "/assets/bettors-tournament/prizes/cup-2.png",
    imagePrizeStyles: {
      top: "13px",
      left: "33px",
      height: "75%"
    },
    imagePrizesBackgroundStyles: {
      top: "-1px",
      left: "0"
    },
    imagePrizeStylesWide: {
      top: "18px",
      left: "47px",
      height: "75%"
    }
  },
  3: {
    place: [3],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._3 place"),
    name: __("Bettors Tournament Single Board_._Prizes 3_._14&nbsp;000&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-3.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-3.png",
    imagePrize: "/assets/bettors-tournament/prizes/cup-3.png",
    imagePrizeStyles: {
      top: "13px",
      left: "33px",
      height: "75%"
    },
    imagePrizesBackgroundStyles: {
      top: "-1px",
      left: "0"
    },
    imagePrizeStylesWide: {
      top: "18px",
      left: "47px",
      height: "75%"
    }
  },
  4: {
    place: [4, 5],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._4-5 place"),
    name: __("Bettors Tournament Single Board_._Prizes 4_._Xiaomi 12&nbsp;Lite"),
    image: "/assets/bettors-tournament/prizes/prize-4.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-4.png",
    imagePrize: "/assets/bettors-tournament/prizes/xiaomi.png",
    imagePrizeStyles: {
      left: "27px",
      top: "40px",
      height: "62%"
    },
    imagePrizesBackgroundStyles: {
      top: "53px",
      left: "-29px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "75px",
      left: "-29px"
    },
    imagePrizeStylesWide: {
      top: "19px",
      left: "44px",
      height: "75%"
    }
  },
  5: {
    place: [6, 10],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._6-10 place"),
    name: __("Bettors Tournament Single Board_._Prizes 5_._Airpods Pro&nbsp;2"),
    image: "/assets/bettors-tournament/prizes/prize-5.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-5.png",
    imagePrize: "/assets/bettors-tournament/prizes/airpods.png",
    imagePrizeStyles: {
      left: "30px",
      top: "52px",
      height: "55%"
    },
    imagePrizesBackgroundStyles: {
      top: "54px",
      left: "-22px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "75px",
      left: "-29px"
    },
    imagePrizeStylesWide: {
      top: "56px",
      left: "38px",
      height: "60%"
    }
  },
  6: {
    place: [11, 15],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._11-15 place"),
    name: __("Bettors Tournament Single Board_._Prizes 6_._Samsung galaxy&nbsp;buds"),
    image: "/assets/bettors-tournament/prizes/prize-6.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-6.png",
    imagePrize: "/assets/bettors-tournament/prizes/samsung-buds.png",
    imagePrizeStyles: {
      left: "13px",
      top: "18px",
      height: "70%"
    },
    imagePrizesBackgroundStyles: {
      top: "49px",
      left: "-22px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "75px",
      left: "-29px"
    },
    imagePrizeStylesWide: {
      top: "31px",
      left: "23px",
      height: "70%"
    }
  },
  7: {
    place: [16, 20],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._16-20 place"),
    name: __("Bettors Tournament Single Board_._Prizes 7_._Freebet 700&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-7.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-7.png",
    imagePrize: "/assets/bettors-tournament/prizes/white-present.png",
    imagePrizeStyles: {
      left: "-74px",
      top: "50px",
      height: "100%"
    },
    imagePrizesBackgroundStyles: {
      top: "23px",
      left: "-41px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "7px",
      left: "-53px",
      height: "120%"
    },
    imagePrizeStylesWide: {
      top: "83px",
      left: "-68px",
      height: "90%"
    }
  },
  8: {
    place: [21, 50],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._21-50 place"),
    name: __("Bettors Tournament Single Board_._Prizes 8_._Freebet 350&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-8.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-8.png",
    imagePrize: "/assets/bettors-tournament/prizes/green-present.png",
    imagePrizeStyles: {
      left: "-36px",
      top: "79px",
      height: "64%"
    },
    imagePrizesBackgroundStyles: {
      top: "23px",
      left: "-41px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "7px",
      left: "-53px",
      height: "120%"
    },
    imagePrizeStylesWide: {
      top: "107px",
      left: "-48px",
      height: "70%"
    }
  },
  9: {
    place: [51, 100],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._51-200 place"),
    name: __("Bettors Tournament Single Board_._Prizes 9_._Freebet 220&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-9.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-9.png",
    imagePrize: "/assets/bettors-tournament/prizes/orange-present.png",
    imagePrizeStyles: {
      left: "-36px",
      top: "79px",
      height: "64%"
    },
    imagePrizesBackgroundStyles: {
      top: "23px",
      left: "-41px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "7px",
      left: "-53px",
      height: "120%"
    },
    imagePrizeStylesWide: {
      top: "107px",
      left: "-48px",
      height: "70%"
    }
  },
  10: {
    place: [101, 250],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._101-250 place"),
    name: __("Bettors Tournament Single Board_._Prizes 10_._Freebet 140&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-10.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-10.png",
    imagePrize: "/assets/bettors-tournament/prizes/red-present.png",
    imagePrizeStyles: {
      left: "-36px",
      top: "79px",
      height: "64%"
    },
    imagePrizesBackgroundStyles: {
      top: "23px",
      left: "-41px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "7px",
      left: "-53px",
      height: "120%"
    },
    imagePrizeStylesWide: {
      top: "107px",
      left: "-48px",
      height: "70%"
    }
  },
  11: {
    place: [251, 500],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._251-500 place"),
    name: __("Bettors Tournament Single Board_._Prizes 11_._Risk Freebet 70&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-11.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-11.png",
    imagePrize: "/assets/bettors-tournament/prizes/soccer-gate.png",
    imagePrizeStyles: {
      left: "-38px",
      top: "61px",
      height: "70%"
    },
    imagePrizesBackgroundStyles: {
      top: "11px",
      left: "-21px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "7px",
      left: "-53px",
      height: "120%"
    },
    imagePrizeStylesWide: {
      top: "107px",
      left: "-48px",
      height: "70%"
    }
  },
  12: {
    place: [501, 700],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._501-700 place"),
    name: __("Bettors Tournament Single Board_._Prizes 12_._Risk Freebet 30&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-12.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-12.png",
    imagePrize: "/assets/bettors-tournament/prizes/tickets.png",
    imagePrizeStyles: {
      left: "-36px",
      top: "24px",
      height: "95%"
    },
    imagePrizesBackgroundStyles: {
      top: "11px",
      left: "-21px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "7px",
      left: "-53px",
      height: "120%"
    },
    imagePrizeStylesWide: {
      top: "51px",
      left: "-48px",
      height: "90%"
    }
  },
  13: {
    place: [701, 1e3],
    placeString: __("Bettors Tournament Single Board_._Prizes string_._701-1000 place"),
    name: __("Bettors Tournament Single Board_._Prizes 13_._Risk Freebet 15&nbsp;GHS"),
    image: "/assets/bettors-tournament/prizes/prize-12.png",
    imageMobile: "/assets/bettors-tournament/prizes/prize-mobile-12.png",
    imagePrize: "/assets/bettors-tournament/prizes/tickets.png",
    imagePrizeStyles: {
      left: "-36px",
      top: "24px",
      height: "95%"
    },
    imagePrizesBackgroundStyles: {
      top: "11px",
      left: "-21px"
    },
    imagePrizesBackgroundStylesWide: {
      top: "7px",
      left: "-53px",
      height: "120%"
    },
    imagePrizeStylesWide: {
      top: "51px",
      left: "-48px",
      height: "90%"
    }
  }
};
export {
  bettorsTournamentPrizes
};
